module.exports = __webpack_public_path__ + "img/onderhoud.5b378635.jpg";